export default __webpack_public_path__ + "maps-examples-view-annotation-marker-thumbnail-480-c41b762b3567c7a9e976fb52244ca6aa.webp";